import { GroupUser } from '@components/pages/Organization/types';
import {
  access_level_api_corporate_subscription_path,
  api_corporate_subscription_path,
  api_corporate_subscriptions_path,
  deactivate_api_corporate_subscription_path,
  reactivate_api_corporate_subscription_path,
} from '@routes';

import request from './request';

export interface CorporateSubscriptionParams {
  corporate_subscription: {
    access_level: number;
  };
  user?: {
    name: string;
    email: string;
  };
}

export interface UpdateCorporateSubscriptionParams extends CorporateSubscriptionParams {
  id: number;
}

export interface ReactivateCorporateSubscriptionParams
  extends Pick<CorporateSubscriptionParams, 'corporate_subscription'> {
  id: number;
}

export interface CorporateSubscriptionResponse {
  message: string;
  user: GroupUser;
}

/**
 * Creates a corporate subscription.
 */
export async function createCorporateSubscription(
  params: CorporateSubscriptionParams
): Promise<CorporateSubscriptionResponse> {
  const response = await request('post', api_corporate_subscriptions_path(), params);
  return response;
}

/**
 * Updates a corporate subscription.
 */
export async function updateCorporateSubscription(
  params: UpdateCorporateSubscriptionParams
): Promise<CorporateSubscriptionResponse> {
  const { id } = params;
  const response = await request('patch', api_corporate_subscription_path({ id }), params);
  return response;
}

/**
 * Updates a corporate subscription's access level.
 */
export async function updateCorporateSubscriptionAccessLevel(
  params: UpdateCorporateSubscriptionParams
): Promise<CorporateSubscriptionResponse> {
  const { id } = params;
  const response = await request(
    'patch',
    access_level_api_corporate_subscription_path({ id }),
    params
  );
  return response;
}

/**
 * Reactivates a corporate subscription.
 */
export async function reactivateCorporateSubscription(
  params: ReactivateCorporateSubscriptionParams
): Promise<CorporateSubscriptionResponse> {
  const { id } = params;
  const response = await request(
    'patch',
    reactivate_api_corporate_subscription_path({ id }),
    params
  );
  return response;
}

/**
 * Deactivates a corporate subscription.
 */
export async function deactivateCorporateSubscription(
  id: number
): Promise<CorporateSubscriptionResponse> {
  const response = await request('patch', deactivate_api_corporate_subscription_path({ id }));
  return response;
}
